

export enum GenericActionsNames {
  RESET = 'RESET',
  RESET_AFTER_MAINTENANCE = 'RESET_AFTER_MAINTENANCE'
}
